import React, { useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { getUser } from "../../redux/actions/userActions";
import { useHistory } from "react-router-dom";
import { LoginWrapper } from "../LoginWrapper";

const Login = ({ userValue, setUserValue, passwordValue, setPasswordValue }) => {
  const dispatch = useDispatch();
  const [notification, setNotification] = useState({ show: false, msg: "" });

  const history = useHistory(); // Get the history object

  const handleRegisterClick = () => {
    history.push("/register");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userValue === "") {
      setNotification({ show: true, msg: "Username is required" });
      return;
    }
    if (passwordValue === "") {
      setNotification({ show: true, msg: "Password is required" });
      return;
    }

    dispatch(
      getUser({
        username: userValue,
        password: passwordValue,
        setNotification,
      })
    );
  };
  return (
    <LoginWrapper>
      <form className="login-form" onSubmit={handleSubmit}>
        <label htmlFor="user">Username</label>
        <Input
          name="user"
          type="text"
          value={userValue}
          autoComplete="username"
          placeholder="Username"
          onChange={(e) => setUserValue(e.target.value)}
          tabIndex="1"
        />
        <div className="password-recover-wrapper">
          <label htmlFor="password">Password</label>
          <Link tabIndex="4" to="/recover">
            Forgot password?
          </Link>
        </div>
        <Input
          name="password"
          type="password"
          autoComplete="current-password"
          value={passwordValue}
          onChange={(e) => setPasswordValue(e.target.value)}
          tabIndex="2"
        />
        {notification.show && <p className="form-notifi">{notification.msg}</p>}

        <div className="fl-mb-2">
          <Button
            style={{ marginTop: "48px" }}
            block="false"
            type="submit"
            fill="true"
            variant="primary"
            tabIndex="3"
          >
            Log Into Your Account
          </Button>
          <Button
            style={{ marginTop: "16px" }}
            block={true} // Updated from "true" to {true}
            type="register"
            fill=""
            variant="primary"
            tabIndex="88"
            onClick={handleRegisterClick}
          >
            Create account
            
          </Button>
          <label htmlFor="version">Version: v2.0</label>
        </div>
      </form>
    </LoginWrapper>
  );
};

export default Login;
